/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Tab4Inputs */

const zh_landing_admin_tab4 = /** @type {(inputs: Landing_Admin_Tab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学生如何学习`)
};

const en_landing_admin_tab4 = /** @type {(inputs: Landing_Admin_Tab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How students learn`)
};

const es_landing_admin_tab4 = /** @type {(inputs: Landing_Admin_Tab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo aprenden los estudiantes`)
};

/**
* | output |
* | --- |
* | "How students learn" |
*
* @param {Landing_Admin_Tab4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_tab4 = /** @type {((inputs?: Landing_Admin_Tab4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Tab4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_tab4(inputs)
	if (locale === "en") return en_landing_admin_tab4(inputs)
	return es_landing_admin_tab4(inputs)
});